import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AxiosController from "../../authentication/AxiosController";
import { useTranslation } from "react-i18next";
import { Alert, Button, Form, Modal, Pagination } from "react-bootstrap";
import Loader from "../../loader/Loader";
import SuppliersTableRow from "./SuppliersTableRow";
import SearchComponent from "./SearchComponent";
import { Helmet } from "react-helmet";
const get_warehouses = (
  slug,
  lang,
  token,
  handleWarehouses,
  page,
  handleLoader,
  code,
  start_date,
  end_date,
  status
) => {
  AxiosController.get(`api/${slug}/${lang}/couriers/get-couriers/${page}`, {
    headers: { Authorization: `Bearer ${token}`},
    params: {
      code,
      is_active:status,
      start_date,
      end_date,
    }
  })
    .then((res) => {
      handleWarehouses(res.data);
      handleLoader(false);
    })
    .catch((e) => {});
};
const createWarehouse = (
  slug,
  lang,
  token,
  name,
  type,
  handleLoader,
  handleWarehouses,
  setShow,
  handleNewCourierNameErr,
  handleCourierTypeErr
) => {
  handleLoader(true);
  AxiosController.post(
    `api/${slug}/${lang}/couriers/add-courier`,
    { name, type },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  )
    .then((res) => {
      get_warehouses(slug, lang, token, handleWarehouses, 1, handleLoader);
      setShow(false);
    })
    .catch((e) => {
      handleNewCourierNameErr(
        e.response.data.errors ? e.response.data.errors.name[0] : ""
      );
      handleCourierTypeErr(
        e.response.data.errors ? e.response.data.errors.type[0] : ""
      );
      handleLoader(false);
    });
};

const Suppliers = () => {
  const { slug, lang } = useParams();
  const location = useLocation();
  const Navigate = useNavigate();
  const urlParams = new URLSearchParams(location.search);
  const token = localStorage.getItem("token");
  const [_] = useTranslation("global");
  const [suppliers, handleSuppliers] = useState([]);
  const [loading, handleLoader] = useState(false);
  const [newCourierName, handleNewCourierName] = useState("");
  const [newCourierNameErr, handleNewCourierNameErr] = useState("");
  const [courierType, handleCourierType] = useState("");
  const [courierTypeErr, handleCourierTypeErr] = useState("");
  const [show, setShow] = useState(false);
  const [page, handlePage] = useState(urlParams.get("page") || 1);
  const [search, handleSearch] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const box_head_dir = lang === "en" ? "ltr" : "rtl";
  const changeParam = (param, value) => {
    urlParams.set(param, value);
    Navigate(`?${urlParams.toString()}`);
  };
  useEffect(() => {
    handleLoader(true);
    const nextPage = parseInt(urlParams.get("page"), 10) || 1;

    const code = urlParams.get("code") || "";
    const start_date = urlParams.get("start_date") || "";
    const end_date = urlParams.get("end_date") || "";
    const status = urlParams.get("is_active") || "";
    handlePage(nextPage);

    get_warehouses(
      slug,
      lang,
      token,
      handleSuppliers,
      nextPage,
      handleLoader,
      code,
      start_date,
      end_date,
      status
    );
  }, [slug, lang, location.search]);

  return (
    <div
      className="position-relative tables-container"
      style={{ minHeight: "100px", width: "100%" }}
    > <Helmet>
    <title>{_("panel.couriers")}</title> 
</Helmet>
      <Button
        className="fs-5 w-25 d-block mb-3 mt-4 align-self-start"
        style={{
          backgroundColor: "rgb(89, 198, 201)",
          border: "none",
          borderRadius: "7px",
        }}
        onClick={() => {
          handleSearch(!search);
        }}
      >
        {_("panel.search")}
      </Button>
      {search ? <SearchComponent /> : ""}
      <Button
        variant="primary"
        onClick={handleShow}
        className="mt-2"
        style={{ background: "#59C6C9", color: "white", border: "none" }}
      >
        {_("panel.add")}
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton className="border-0" dir={box_head_dir}>
          <Modal.Title className="flex-grow-1">
            {_("panel.addwarehouse")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body dir={box_head_dir}>
          {label_input(
            _("panel.courierName"),
            newCourierName,
            handleNewCourierName
          )}
          {newCourierNameErr ? (
            <Alert variant="danger">{newCourierNameErr}</Alert>
          ) : (
            ""
          )}
          <label htmlFor="exampleInputEmail1" className="form-label">
            {_("panel.type")}
          </label>
          <Form.Group className="mb-3 flex-grow-1">
            <Form.Select
              onChange={(e) => {
                handleCourierType(e.target.value);
              }}
            >
              <option selected={true}></option>
              <option selected={false} value={"Individual"}>
                {_("panel.Individual")}
              </option>
              <option selected={false} value={"Company"}>
                {_("panel.Company")}
              </option>
            </Form.Select>
            {courierTypeErr ? (
              <Alert variant="danger">{courierTypeErr}</Alert>
            ) : (
              ""
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="border-0" dir={box_head_dir}>
          <Button
            variant="primary"
            onClick={() => {
              createWarehouse(
                slug,
                lang,
                token,
                newCourierName,
                courierType,
                handleLoader,
                handleSuppliers,
                setShow,
                handleNewCourierNameErr,
                handleCourierTypeErr
              );
            }}
          >
            {_("panel.save")}
          </Button>
        </Modal.Footer>
      </Modal>
      <Loader active={loading} />
      <div
        className="tables-container d-flex flex-column px-2"
        style={{ position: "relative", flexGrow: 3 }}
      >
        <div
          className={`header d-flex ${
            lang === "en" ? "flex-row" : "flex-row"
          } gap-3 align-items-center justify-content-between`}
        >
          <h3 className="fs-1" style={{ color: "rgba(89, 198, 201, 1)" }}>
            {_("panel.couriers")}
          </h3>
        </div>
        <div className="footer d-flex flex-column flex-grow-1">
          {suppliers.data ? (
            <SuppliersTableRow
              payments_list={suppliers.data}
              handleLoader={handleLoader}
            />
          ) : (
            ""
          )}
          {suppliers.data ? (
            <Pagination
              className="m-auto flex-wrap"
              dir={lang === "ar" ? "ltr" : ""}
            >
              <Pagination.First onClick={() => changeParam("page", 1)} />
              <Pagination.Prev
                onClick={() =>
                  page - 1 > 0 ? changeParam("page", page - 1) : 1
                }
              />
              {suppliers["links"].map((element, index, arr) => {
                if (index == 0 || arr.length - 1 == index) {
                  return "";
                } else {
                  return (
                    <Pagination.Item
                      active={element["active"] ? true : false}
                      onClick={(e) =>
                        element["label"] != "..."
                          ? changeParam("page", parseInt(element["label"]))
                          : ""
                      }
                    >
                      {element["label"]}
                    </Pagination.Item>
                  );
                }
              })}
              <Pagination.Next onClick={() => changeParam("page", page + 1)} />
              <Pagination.Last
                onClick={() => changeParam("page", suppliers["last_page"])}
              />
            </Pagination>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};
const label_input = (label, newWarehouseName, handleNewWarehouseName) => {
  return (
    <div className="mb-3">
      <label htmlFor="exampleInputEmail1" className="form-label">
        {label}
      </label>
      <input
        type="text"
        className="form-control py-2 egp"
        id="exampleInputEmail1"
        aria-describedby="emailHelp"
        value={newWarehouseName}
        onInput={(e) => handleNewWarehouseName(e.target.value)}
      />
    </div>
  );
};
export default Suppliers;
